<template>
  <div>
    <custom-actions>
      <template #header> </template>
      <el-form
        :model="searchForm"
        ref="formData"
        inline
        class="global-form-label-width account-form"
        label-width="100px"
      >
        <el-form-item label="品种规格" prop="specName">
          <el-input
            clearable
            v-model="searchForm.specName"
            placeholder="请输入品种规格"
          />
        </el-form-item>

        <!-- <el-form-item label="商品编码" prop="productCode">
          <el-select
            filterable
            clearable
            v-model="searchForm.productCode"
            placeholder="请选择商品编号"
          >
            <el-option
              v-for="(item, index) of productCodeList"
              :value="item.dicCode"
              :label="item.dicValue"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="是否展示" prop="isDisplay">
          <el-select v-model="searchForm.isDisplay" clearable>
            <el-option value="1" label="是"></el-option>
            <el-option value="2" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否散油" prop="isBulkOil">
          <el-select v-model="searchForm.isBulkOil" clearable>
            <el-option
              :value="item.value"
              :label="item.label"
              v-for="(item, index) of isBulkOilArr"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="规格图片" prop="specImage">
          <template v-slot="{ row }">
            <el-image
              v-if="row.specImage"
              style="width: 60px; height: 60px"
              :src="row.specImage"
              :preview-src-list="[row.specImage]"
              fit="cover"
            />
            <el-image
              v-else
              style="width: 60px; height: 60px"
              :src="YouImg"
              :preview-src-list="[YouImg]"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column
          min-width="120"
          label="品种规格"
          prop="specName"
        ></el-table-column>
        <!-- <el-table-column
          min-width="120"
          label="粮油类型"
          prop="typeName"
        ></el-table-column> -->
        <el-table-column
          min-width="120"
          label="价格差(元)"
          prop="priceDiff"
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="单价(元)"
          prop="currentPrice"
        >
        </el-table-column>
        <!--
        <el-table-column min-width="120" label="是否发布" prop="isPublished">
          <template v-slot="{ row }">
            <el-tag v-if="row.isPublished === 1" type="success">已发布</el-tag>
            <el-tag v-if="row.isPublished == '0'" type="danger">未发布</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column min-width="120" label="是否展示" prop="isDisplay">
          <template v-slot="{ row }">
            <el-tag v-if="row.isDisplay == 1" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="是否散油" prop="isBulkOil">
          <template v-slot="{ row }">
            {{ row.isBulkOil == "0" ? "否" : row.isBulkOil == "1" ? "是" : "" }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="120"
          label="单位"
          prop="unit"
        ></el-table-column>

        <!-- <el-table-column
          min-width="160"
          label="商品编码"
          prop="productCode"
        ></el-table-column> -->
        <!-- <el-table-column
          min-width="140"
          label="创建时间"
          prop="ctime"
        ></el-table-column> -->

        <el-table-column width="200" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button
              type="text"
              @click="$router.push('/ycpriceControl/edit?specId=' + row.specId)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="$router.push('/ycpriceControl/detail?specId=' + row.specId)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import YouImg from '@/assets/you.png'

export default {
  name: 'priceControl',
  mixins: [keepAlive],
  components: {},
  data() {
    return {
      isBulkOilArr: [
        {
          label: '否',
          value: '0'
        },
        {
          label: '是',
          value: '1'
        }
      ],
      tableData: [],
      YouImg,
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        specName: '',
        isBulkOil: '',
        productCode: '',
        isDisplay: ''
      },

      showDlg: false,
      rowId: '',
      productCodeList: []
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    }
  },
  created() {
    // this.loadDict()
    this.loadData()
  },
  methods: {
    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.priceControl.selectYxSpecPriceByList, {
          params: params
        })
        .then(res => {
          res.list.forEach(item => {
            item.currentPrice = ''
            if (item.priceList && item.priceList.length > 0) {
              if (item.priceList.length === 1) {
                item.currentPrice = item.priceList[0].specPrice
              } else {
                const nums = item.priceList.map(item => item.specPrice)

                const max = Math.max(...nums)
                const min = Math.min(...nums)
                item.currentPrice = min + ' ~ ' + max
              }
            }
          })
          this.tableData = res.list
          this.total = res.total
        })
    },
    loadDict() {
      this.$axios
        .get(this.$apis.common.selectDicByList, {
          params: { dicType: 'goodsCode' }
        })
        .then(res => {
          this.productCodeList = res.goodsCode || []
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="scss"></style>
